import type { TabItem } from '../containers/LabelPerf/components/Tabs';
import type { HistRange, LabelPerfFilters } from '../types/label-perf';

export const HIST_RANGE: Record<HistRange, number> = {
  week: 7,
  month: 30,
  year: 365,
  allTime: 365 * 2,
};

export const CHART_TABS: TabItem[] = [
  { id: 'allTime', name: 'All time' },
  { id: 'year', name: '12M' },
  { id: 'month', name: '30D' },
];

export const DEFAULT_TOP_TEN_TAB = 'streamsUp';
export const DEFAULT_CHART_RANGE = 'year';

export const DEFAULT_LABELS_FILTERS: LabelPerfFilters = {
  labels: [],
  isCrossover: false,
  isOnRoster: undefined,
};
